import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Breadcrumbs from "../ui/Breadcrumbs";
import {withRouter} from 'react-router-dom';
import CountersCard from '../ui/CountersCard';
import Grid from '@material-ui/core/Grid';
import axios from "axios";
import notify from "devextreme/ui/notify";

const items = [
  {
    label: "Опросы",
    link: "#"
  },
];

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
});

const Quiz = ({history}) => {
  const classes = useStyles();
  let [manageQuizCounter, setManageQuizCounter] = useState(null);
  let [enjoyQuizCounter, setEnjoyQuizCounter] = useState(null);

  useEffect(() => {
    axios.get("/work/api/dashboard/counter/manage-quiz", {
      headers: {
        'Accept': 'application/json'
      },
    }).then(response => {
      setManageQuizCounter(response.data);
    }).catch(() => notify({
      closeOnClick: true,
      closeOnOutsideClick: true,
      message: 'Не удалось загрузить показатель "Проведение опросов"'
    }, 'error'))
  }, [setManageQuizCounter]);

  useEffect(() => {
    axios.get("/work/api/dashboard/counter/enjoy-quiz", {
      headers: {
        'Accept': 'application/json'
      },
    }).then(response => {
      setEnjoyQuizCounter(response.data);
    }).catch(() => notify({
      closeOnClick: true,
      closeOnOutsideClick: true,
      message: 'Не удалось загрузить показатель "Участие в опросах"'
    }, 'error'))
  }, [setEnjoyQuizCounter]);

  const handleClick = (link) => {
    history.push(link);
  }

return (
    <div>
      <Breadcrumbs items={items} />
      <div className={classes.root}>
        <Grid container spacing={0} justify="flex-start" alignItems="flex-start">
          <Grid item xs={12} sm={6} md={4} xl={3}>
            <CountersCard
              data={enjoyQuizCounter}
              onClick={handleClick}
              goTo={'/work/app/quiz/active'}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} xl={3}>
            <CountersCard
              data={manageQuizCounter}
              onClick={handleClick}
              goTo={'/work/app/quiz/manage'}
            />
          </Grid>
        </Grid>
      </div>
    </div>
  )
}

export default (withRouter(Quiz));
